import { RouteRecordRaw, createRouter, createWebHashHistory } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/home'),
  },
  {
    path: '/journey',
    component: () => import('../components/modal'),
    children: [
      {
        path: 'recommend',
        name: 'recommend',
        component: () => import('../components/journey'),
      },
      {
        path: 'plan',
        name: 'plan',
        component: () => import('../components/journey'),
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import('../components/journey/detail'),
      },
    ],
  },
  {
    path: '/data',
    component: () => import('../components/modal'),
    children: [
      {
        path: 'summary',
        name: 'data_summary',
        component: () => import('../components/summary/summaryV2'),
        // (process.config as any).brand === 'alps' || (process.config as any).brand === 'fy'
        //   ? import('../components/summary/summaryV2')
        //   : import('../components/summary'),
        // component: () => import('../components/summary'),
      },
      {
        path: 'choose-city',
        name: 'data_chooseCity',
        component: () => import('../components/summary/chooseCity'),
      },
    ],
  },
  {
    path: '/wishpower',
    name: 'wishpower',
    component: () => import('../components/modal'),
    children: [
      {
        path: 'index',
        name: 'wishpower_index',
        component: () => import('../components/wishpower'),
      },
      {
        path: 'choose-city',
        name: 'wishpower_chooseCity',
        component: () => import('../components/wishpower/chooseCity'),
      },
    ],
  },
  {
    path: '/newStation',
    name: 'newStation',
    component: () => import('../components/newStation/newStationList'),
  },
  {
    path: '/county_layout',
    name: 'countyLayout',
    component: () => import('../components/countyLayout/countyLayoutList'),
  },
  {
    path: '/resource', // 资源
    name: 'resource',
    component: () => import('../components/resourceCard'),
    props: (route) => ({
      id: route.query.id,
      location: route.query.location,
      pointType: route.query.pointType,
      pointSubType: route.query.pointSubType,
    }),
  },
  {
    path: '/pin', // 戳点
    name: 'pin',
    component: () => import('../components/resourceCard'),
    props: (route) => ({
      id: route.query.id,
      location: route.query.location,
      pointType: route.query.pointType,
      pointSubType: route.query.pointSubType,
    }),
  },
  {
    path: '/around_resource', // 附近资源
    name: 'around_resource',
    component: () => import('../components/resourceCard'),
    props: (route) => ({
      id: route.query.id,
      location: route.query.location,
      pointType: route.query.pointType,
      pointSubType: route.query.pointSubType,
    }),
  },
  {
    path: '/oauth_callback',
    name: 'oauth_callback',
    redirect: '/',
  },
  {
    path: '/access/denied',
    name: 'access_denied',
    component: () => import('../components/error'),
  },
]

export const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,
  history: createWebHashHistory(process.env.MODE === 'ssr' ? void 0 : '/pe/h5/static/chargermap'),
})

// 拦截所有以 /& 开头的路由，重定向到 home
// 在nio app中扫码会给链接上加上&wv，需要特殊处理
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/&')) {
    next({ name: 'home', replace: true })
  } else {
    next()
  }
})

/**
 * 清空路由
 * @param routeNameList
 */
export const resetRouter = (routeNameList = []) => {
  const whiteList = ['home', 'oauth_callback', 'access_denied']
  //获取所有路由
  router.getRoutes().forEach((route) => {
    const { name } = route //获取路由name
    if (name && !whiteList.concat(routeNameList).includes(name as string)) {
      //路由不属于白名单,则删除
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

declare global {
  interface Window {
    backHistoryNum: number // 用于记录返回的历史记录数
  }
}

/**
 * 清空route回到home
 */
export const clearHistory = async () => {
  // console.log('===============clearHistory=====================')
  // console.log(history.state.backHistoryNum)
  // console.log('====================================')
  if (history.state.backHistoryNum && history.state.backHistoryNum > 0) {
    await router.go(-history.state.backHistoryNum)
  }
  window.backHistoryNum = 0
}
